import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

import { router } from './router'
import PrimeVue from "primevue/config";
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import 'primeicons/primeicons.css';
import Tooltip from 'primevue/tooltip';
import { definePreset } from '@primeuix/themes';
import Aura from '@primevue/themes/lara';
import {initializeCsrfToken} from "@/services/genericApi.ts";

const Indigo = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});


const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

app.use(PrimeVue, {
    // Default theme configuration
    theme: {
        preset: Indigo,
    }
});
app.use(ConfirmationService);
app.use(ToastService);
app.directive('tooltip', Tooltip);
initializeCsrfToken().catch(() => {});

app.use(router);
router.isReady().then(() => {
    console.log('>>> ROUTER READY!!! (about to mount)');
    app.mount('#app')
});
